import { ref, watchEffect, onUnmounted, Ref, watch } from '@vue/composition-api';


export function useCountdown(isShowImg: Ref, isShow: Ref, handleClose: Function) {
  /** 计时器 */
  const timer = ref(0);
  /** 倒计时 */
  const time = ref(8);
  watch(isShowImg, () => {
    clearInterval(timer.value);
    if (isShowImg.value) {
      timer.value = setInterval(() => {
        if (time.value <= 0) {
          return clearInterval(timer.value);
        }
        time.value -= 1;
      }, 1000);
    }
  });
  watchEffect(() => {
    // 不被展示时，不触发
    if (!isShow) return;
    if (time.value === 0) {
      // 触发关闭事件
      handleClose();
    }
  });
  onUnmounted(() => {
    clearInterval(timer.value);
  });
  return {
    time,
  };
}
